import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import HttpManager from "../../services/HttpManager";
import TarjetaAprobacion from "./tarjetaAprobacion";
import { Aprobacion, fichaLink } from "./tipos";

/*
	Por Aprobar (pestaña de Promociones; antes en Descuentos): las aprobaciones pendientes del plantel con la misma tarjeta de WappTeam (Aprobar, Rechazar, Ver en la Ficha).
	GET aprobaciones?status=pendiente. Quien decide aquí lo hace igual que en el mensaje de WappTeam: la primera decisión gana.
*/
const http = HttpManager.getInstance();

/** Cuántas hay pendientes, para el número de la pestaña. */
export const contarPorAprobar = (campusId: number): Promise<number> =>
	http.aprobacionesService.lista(campusId, "pendiente", 1).then((r) => Number(r.data.total) || 0).catch(() => 0);

const ListaPorAprobar: React.FC<{ campusId: number; onCount?: (n: number) => void }> = ({ campusId, onCount }) => {
	const navigate = useNavigate();
	const [rows, setRows] = useState<Aprobacion[] | null>(null);
	const [error, setError] = useState<string | null>(null);

	const cargar = useCallback(() => {
		http.aprobacionesService.lista(campusId, "pendiente", 1)
			.then((r) => { setRows(r.data.rows || []); setError(null); onCount?.(Number(r.data.total) || (r.data.rows || []).length); })
			.catch((e: any) => setError(e?.response?.data?.message || "No se pudo cargar. Intenta otra vez."));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campusId]);
	useEffect(() => { setRows(null); cargar(); }, [cargar]);

	if (error) return <div className="wdAviso">{error}</div>;
	if (rows === null) return <div className="loader" />;
	if (rows.length < 1) return <div className="wdTenue">Nada por aprobar.</div>;
	return (
		<div style={{ display: "flex", flexDirection: "column", gap: 12, alignItems: "flex-start" }}>
			{rows.map((a) => <TarjetaAprobacion key={a.id} a={a} onVerFicha={(x) => navigate(fichaLink(x))} onCambio={cargar} />)}
		</div>
	);
};

export default ListaPorAprobar;
